import { SetStateAction, useState } from "react";
import RegisterForm from "../_.segments/RegisterForm";
import { useTranslation } from "react-i18next";
import FormInput from "~/components/forms/FormInput";
import { handle } from "../_.segments/route";
import CheckboxesInput from "~/components/forms/CheckboxesInput";
import CheckboxInput from "~/components/forms/CheckboxInput";

export default function CreateDesignerForm({
  setDisplayForm,
}: {
  setDisplayForm: React.Dispatch<SetStateAction<boolean>>;
}) {
  const { t } = useTranslation(handle.i18n);
  const [showOtherSkills, setShowOtherSkills] = useState(false);

  return (
    <RegisterForm setDisplayForm={setDisplayForm}>
      <input type="hidden" name="type" value="designers" />
      <FormInput
        label={t("form.reside.label")}
        name="location"
        placeholder={t("form.reside.placeholder")}
      />

      <CheckboxesInput
        name="skills"
        label={t("designers.form.skills.label")}
        options={[
          "Clo3D",
          "Adobe Illustrator",
          "Tukatech",
          "Optitex",
          "PAD System",
          "Richpeace CAD",
          "Accumark CAD",
        ]}
      >
        <CheckboxInput
          onChange={(e) => {
            setShowOtherSkills(e.target.checked);
          }}
          id="other"
          value="other"
          name="skills"
        >
          {t("form.other")}
        </CheckboxInput>
      </CheckboxesInput>

      {showOtherSkills ? (
        <FormInput
          label={t("form.otherSkills")}
          name="otherSkills"
          placeholder={t("form.enter")}
        />
      ) : null}

      <FormInput
        label={t("designers.form.interested")}
        name="interested"
        placeholder={t("form.enter")}
      />

      <FormInput
        label={t("designers.form.time.label")}
        name="dedicatedTime"
        placeholder={t("designers.form.time.placeholder")}
      />
    </RegisterForm>
  );
}
